import api from './api';

export interface ICreateVacancy {
  cityDisplayName: string,
  city: string,
  cityOrder: number,
  experienceDisplayName: string,
  experience: string,
  experienceOrder: number,
  employmentTypeDisplayName: string,
  employmentType: string,
  employmentTypeOrder: number,
  scheduleDisplayName: string,
  schedule: string,
  scheduleOrder: number,
  salaryDisplayName: string,
  salary: string,
  salaryOrder: number,
  workFormatDisplayName: string,
  workFormat: string,
  workFormatOrder: number,
  gradeDisplayName: string,
  grade: string,
  gradeOrder: number,
  titleDisplayName: string,
  title: string,
  titleOrder: number,
  responsibilitiesDisplayName: string,
  responsibilities: string,
  responsibilitiesOrder: number,
  descriptionVacancyDisplayName: string,
  descriptionVacancy: string,
  descriptionVacancyOrder: number,
  termsName: string,
  terms: string,
  termsOrder: number,
  requirementsDisplayName: string,
  requirements: string,
  requirementsOrder: number,
  division: string,
  group: string,
  alertText: string,
  alertTextRecommendation: string,
  responsibleUser: string,
  private: false,
  status: string,
}

async function createVacancyAPI(vacancy: ICreateVacancy) {
  const response = await api.post(
    'admin_vacancy/',
    vacancy,
  );
  return response?.data;
}

export default createVacancyAPI;
